const faqs = [
  {
    q: '69视频需要注册吗？观看收费吗？',
    a: '69视频完全不需要注册登录即可观看所有内容，平台所有影视资源均为免费在线观看。我们聚合了西瓜视频免费、91在线视频等渠道的公开资源，不会有任何收费项目，请放心使用。',
  },
  {
    q: '为什么有些视频播放不流畅？',
    a: '播放流畅度主要取决于您的网络环境和视频源服务器状态。建议检查网络连接，或尝试切换画质（标清/高清/超清）来适应不同网络条件。69视频采用智能CDN加速技术，大多数情况下都能保证流畅播放。',
  },
  {
    q: '支持哪些设备观看？可以投屏吗？',
    a: '69视频支持电脑（Windows/Mac）、手机（Android/iOS）、平板等多种设备在线观看。平台支持DLNA和AirPlay投屏协议，您可以将视频投射到智能电视或投影仪上观看，享受大屏观影体验。',
  },
  {
    q: '视频内容多久更新一次？',
    a: '平台内容每日更新。西瓜视频免费和91在线视频的热门剧集、综艺节目通常在首播后24小时内上线。电影、动漫、纪录片等也会根据片源情况及时更新。关注首页「最新动态」板块可获取实时更新资讯。',
  },
  {
    q: '如何反馈问题或推荐影视资源？',
    a: '您可以通过「联系我们」板块中的邮箱或官方微信与我们取得联系。如果您有想看的影视内容或发现了平台问题，欢迎随时告诉我们。我们重视每一位用户的反馈，会尽快处理您的建议。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
            <span className="text-xs text-primary-400 whitespace-nowrap">帮助中心</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-50 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-400 max-w-xl mx-auto">
            关于69视频、西瓜视频免费、91在线视频的使用问题，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq) => (
            <div key={faq.q} className="bg-background-200/40 rounded-xl overflow-hidden">
              <div className="p-5 md:p-6">
                <div className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-500/20 mt-0.5">
                    <i className="ri-question-line text-xs text-primary-400"></i>
                  </span>
                  <div>
                    <h3 className="text-sm md:text-base font-medium text-foreground-200 mb-2">{faq.q}</h3>
                    <p className="text-sm text-foreground-400 leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}